(function () {
  "use strict";

  var header = document.getElementById("site-header");
  var megaMenu = document.getElementById("mega-menu");
  var hamburger = document.querySelector(".header-hamburger");
  var closeBtn = document.querySelector(".mega-menu__close");
  var backdrop = document.querySelector("[data-close-menu]");

  if (!header || !megaMenu) return;

  var menuOpen = false;

  /* ── ABRIR MENÚ ── */
  function openMenu() {
    menuOpen = true;
    megaMenu.classList.add("is-open");
    megaMenu.setAttribute("aria-hidden", "false");
    if (hamburger) hamburger.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
  }

  /* ── CERRAR MENÚ ── */
  function closeMenu() {
    menuOpen = false;
    megaMenu.classList.remove("is-open");
    megaMenu.setAttribute("aria-hidden", "true");
    if (hamburger) hamburger.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  }

  /* ── EVENTS ── */
  if (hamburger)
    hamburger.addEventListener("click", function () {
      if (menuOpen) closeMenu();
      else openMenu();
    });
  if (closeBtn) closeBtn.addEventListener("click", closeMenu);
  if (backdrop) backdrop.addEventListener("click", closeMenu);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && menuOpen) closeMenu();
  });

  /* ── VIDEO HERO: autoplay seguro ── */
  var heroVideo = document.querySelector(".video-hero__video");
  if (heroVideo) {
    heroVideo.muted = true;
    heroVideo.play().catch(function () {
      heroVideo.style.display = "none";
    });
  }
})();
